function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.4815 5.51852C9.85185 4.88889 8.96296 4.48148 8 4.48148C7.03704 4.48148 6.14815 4.87037 5.51852 5.51852C4.88889 6.14815 4.48148 7.03704 4.48148 8C4.48148 8.96296 4.88889 9.85185 5.51852 10.4815C6.14815 11.1111 7.03704 11.5185 8 11.5185C8.96296 11.5185 9.85185 11.1296 10.4815 10.4815C11.1111 9.85185 11.5185 8.96296 11.5185 8C11.5185 7.03704 11.1296 6.14815 10.4815 5.51852ZM9.81481 9.81481C9.35185 10.2778 8.7037 10.5556 8 10.5556C7.2963 10.5556 6.64815 10.2778 6.18519 9.81481C5.72222 9.35185 5.44444 8.7037 5.44444 8C5.44444 7.2963 5.72222 6.64815 6.18519 6.18519C6.64815 5.72222 7.2963 5.44444 8 5.44444C8.7037 5.44444 9.35185 5.72222 9.81481 6.18519C10.2778 6.64815 10.5556 7.2963 10.5556 8C10.5556 8.7037 10.2778 9.35185 9.81481 9.81481Z",
  fill: "#D18F1F"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M14.5185 7.51852H13.0926C12.8333 7.51852 12.6111 7.74074 12.6111 8C12.6111 8.25926 12.8333 8.48148 13.0926 8.48148H14.5185C14.7778 8.48148 15 8.25926 15 8C15 7.74074 14.7778 7.51852 14.5185 7.51852Z",
  fill: "#D18F1F"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M8 12.6111C7.74074 12.6111 7.51852 12.8333 7.51852 13.0926V14.5185C7.51852 14.7778 7.74074 15 8 15C8.25926 15 8.48148 14.7778 8.48148 14.5185V13.0926C8.48148 12.8333 8.25926 12.6111 8 12.6111Z",
  fill: "#D18F1F"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M12.9444 12.2778L11.9259 11.2593C11.7593 11.0741 11.4444 11.0741 11.2593 11.2593C11.0741 11.4444 11.0741 11.7407 11.2593 11.9259L12.2778 12.9444C12.463 13.1296 12.7593 13.1296 12.9444 12.9444C13.1296 12.7593 13.1296 12.463 12.9444 12.2778Z",
  fill: "#D18F1F"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M8 1C7.74074 1 7.51852 1.22222 7.51852 1.48148V2.90741C7.51852 3.16667 7.74074 3.38889 8 3.38889C8.25926 3.38889 8.48148 3.16667 8.48148 2.90741V1.48148C8.48148 1.22222 8.25926 1 8 1Z",
  fill: "#D18F1F"
});
var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M12.963 3.05556C12.7778 2.87037 12.4815 2.87037 12.2963 3.05556L11.2778 4.07407C11.0926 4.25926 11.0926 4.55556 11.2778 4.74074C11.4444 4.92593 11.7593 4.92593 11.9444 4.74074L12.963 3.72222C13.1481 3.53704 13.1481 3.24074 12.963 3.05556Z",
  fill: "#D18F1F"
});
var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M2.90741 7.51852H1.48148C1.22222 7.51852 1 7.74074 1 8C1 8.25926 1.2037 8.48148 1.48148 8.48148H2.90741C3.16667 8.48148 3.38889 8.25926 3.38889 8C3.38889 7.74074 3.16667 7.51852 2.90741 7.51852Z",
  fill: "#D18F1F"
});
var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M4.72222 11.2593C4.55556 11.0741 4.24074 11.0741 4.05556 11.2593L3.03704 12.2778C2.85185 12.463 2.85185 12.7593 3.03704 12.9444C3.22222 13.1296 3.51852 13.1296 3.7037 12.9444L4.72222 11.9259C4.90741 11.7407 4.90741 11.4444 4.72222 11.2593Z",
  fill: "#D18F1F"
});
var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M4.72222 4.07407L3.7037 3.05556C3.51852 2.87037 3.22222 2.87037 3.03704 3.05556C2.85185 3.24074 2.85185 3.53704 3.03704 3.72222L4.05556 4.74074C4.24074 4.92593 4.53704 4.92593 4.72222 4.74074C4.90741 4.55556 4.90741 4.25926 4.72222 4.07407Z",
  fill: "#D18F1F"
});
var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M10.4815 5.51852C9.85185 4.88889 8.96296 4.48148 8 4.48148C7.03704 4.48148 6.14815 4.87037 5.51852 5.51852C4.88889 6.14815 4.48148 7.03704 4.48148 8C4.48148 8.96296 4.88889 9.85185 5.51852 10.4815C6.14815 11.1111 7.03704 11.5185 8 11.5185C8.96296 11.5185 9.85185 11.1296 10.4815 10.4815C11.1111 9.85185 11.5185 8.96296 11.5185 8C11.5185 7.03704 11.1296 6.14815 10.4815 5.51852ZM9.81481 9.81481C9.35185 10.2778 8.7037 10.5556 8 10.5556C7.2963 10.5556 6.64815 10.2778 6.18519 9.81481C5.72222 9.35185 5.44444 8.7037 5.44444 8C5.44444 7.2963 5.72222 6.64815 6.18519 6.18519C6.64815 5.72222 7.2963 5.44444 8 5.44444C8.7037 5.44444 9.35185 5.72222 9.81481 6.18519C10.2778 6.64815 10.5556 7.2963 10.5556 8C10.5556 8.7037 10.2778 9.35185 9.81481 9.81481Z",
  stroke: "#D18F1F",
  strokeWidth: 0.5
});
var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M14.5185 7.51852H13.0926C12.8333 7.51852 12.6111 7.74074 12.6111 8C12.6111 8.25926 12.8333 8.48148 13.0926 8.48148H14.5185C14.7778 8.48148 15 8.25926 15 8C15 7.74074 14.7778 7.51852 14.5185 7.51852Z",
  stroke: "#D18F1F",
  strokeWidth: 0.5
});
var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M8 12.6111C7.74074 12.6111 7.51852 12.8333 7.51852 13.0926V14.5185C7.51852 14.7778 7.74074 15 8 15C8.25926 15 8.48148 14.7778 8.48148 14.5185V13.0926C8.48148 12.8333 8.25926 12.6111 8 12.6111Z",
  stroke: "#D18F1F",
  strokeWidth: 0.5
});
var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M12.9444 12.2778L11.9259 11.2593C11.7593 11.0741 11.4444 11.0741 11.2593 11.2593C11.0741 11.4444 11.0741 11.7407 11.2593 11.9259L12.2778 12.9444C12.463 13.1296 12.7593 13.1296 12.9444 12.9444C13.1296 12.7593 13.1296 12.463 12.9444 12.2778Z",
  stroke: "#D18F1F",
  strokeWidth: 0.5
});
var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M8 1C7.74074 1 7.51852 1.22222 7.51852 1.48148V2.90741C7.51852 3.16667 7.74074 3.38889 8 3.38889C8.25926 3.38889 8.48148 3.16667 8.48148 2.90741V1.48148C8.48148 1.22222 8.25926 1 8 1Z",
  stroke: "#D18F1F",
  strokeWidth: 0.5
});
var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M12.963 3.05556C12.7778 2.87037 12.4815 2.87037 12.2963 3.05556L11.2778 4.07407C11.0926 4.25926 11.0926 4.55556 11.2778 4.74074C11.4444 4.92593 11.7593 4.92593 11.9444 4.74074L12.963 3.72222C13.1481 3.53704 13.1481 3.24074 12.963 3.05556Z",
  stroke: "#D18F1F",
  strokeWidth: 0.5
});
var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M2.90741 7.51852H1.48148C1.22222 7.51852 1 7.74074 1 8C1 8.25926 1.2037 8.48148 1.48148 8.48148H2.90741C3.16667 8.48148 3.38889 8.25926 3.38889 8C3.38889 7.74074 3.16667 7.51852 2.90741 7.51852Z",
  stroke: "#D18F1F",
  strokeWidth: 0.5
});
var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M4.72222 11.2593C4.55556 11.0741 4.24074 11.0741 4.05556 11.2593L3.03704 12.2778C2.85185 12.463 2.85185 12.7593 3.03704 12.9444C3.22222 13.1296 3.51852 13.1296 3.7037 12.9444L4.72222 11.9259C4.90741 11.7407 4.90741 11.4444 4.72222 11.2593Z",
  stroke: "#D18F1F",
  strokeWidth: 0.5
});
var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M4.72222 4.07407L3.7037 3.05556C3.51852 2.87037 3.22222 2.87037 3.03704 3.05556C2.85185 3.24074 2.85185 3.53704 3.03704 3.72222L4.05556 4.74074C4.24074 4.92593 4.53704 4.92593 4.72222 4.74074C4.90741 4.55556 4.90741 4.25926 4.72222 4.07407Z",
  stroke: "#D18F1F",
  strokeWidth: 0.5
});
function SvgDay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDay);
export default __webpack_public_path__ + "static/media/day.a18c1f4b6f017e90180e55a04f0e417f.svg";
export { ForwardRef as ReactComponent };